export interface SurveyVersionDraftTranslation {
  language: string
  name: string
  description: string
}

export interface PersistedSurveyVersionDraft {
  business: string
  isActive: boolean
  translations: SurveyVersionDraftTranslation[]
}

export interface BuildSurveyVersionDraftInput {
  business: string
  isActive: boolean
  translations: SurveyVersionDraftTranslation[]
}

export function buildSurveyVersionDraft(
  input: BuildSurveyVersionDraftInput,
): PersistedSurveyVersionDraft {
  return {
    business: input.business,
    isActive: input.isActive,
    translations: input.translations,
  }
}

export function hasSurveyVersionDraftContent(input: BuildSurveyVersionDraftInput): boolean {
  return (
    input.isActive ||
    input.translations.some((row) => !!(row.name.trim() || row.description.trim()))
  )
}
